import { createPsd2SyncStore } from "~/stores/psd2SyncStore";

/** The GoCardless aggregator, for a customer and for a company. */

export const usePsd2GocaStore = createPsd2SyncStore({
  id: 'psd2GocaStore',
  baseUrl: '/sync/gocardless/psd2',
});

export const usePsd2BusinessGocaStore = createPsd2SyncStore({
  id: 'psd2BusinessGocaStore',
  baseUrl: '/sync/business/gocardless/psd2',
});
